import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { colours } from "@/utils";
import { Device } from "@/utils/device";
import { CXXL, CL } from "@/components/Typography";

type StatContentProps = {
  background?: string;
  copy: React.ReactNode;
  author?: React.ReactNode | string;
  copyColour?: string;
  authorColour?: string;
};

type StyleProps = {
  background?: string;
};

const StatContent: FunctionComponent<StatContentProps> = (props) => {
  return (
    <S.Section background={props.background} data-cy="stat-content">
      <S.Copy colour={props.copyColour}>{props.copy}</S.Copy>
      {!!props.author && <CL colour={props.authorColour}>{props.author}</CL>}
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section<StyleProps>`
  width: 100%;
  padding: 10%;
  background: ${(p) => p.background || colours.shell};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2rem;

  @media (min-width: ${Device.tablet}) {
    text-align: center;
    padding: 5% 10%;
    gap: 4rem;
  }
`;

S.Copy = styled(CXXL)`
  font-size: 1.5rem;
  line-height: 2rem;

  @media (min-width: ${Device.mobile}) {
    font-size: 2rem;
    line-height: 2.5rem;
  }

  @media (min-width: ${Device.tablet}) {
    font-size: 2.5rem;
    line-height: 3rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 3.5rem;
    line-height: 4rem;
  }
`;

export default StatContent;
